<template>
  <div class="abstracts">
    <h3 class="activeR">高新证书</h3>
    <el-divider></el-divider>
    <div>
      <img src="../../assets/certificate.png" />
    </div>
  </div>
</template>
<style scoped lang="less">
.abstracts {
  img {
    width: 900px;
  }
}
</style>
